// extracted by mini-css-extract-plugin
export var backgroundImageContainer = "ExperienceCardModule-module--backgroundImageContainer--a2bca";
export var cardContainer = "ExperienceCardModule-module--cardContainer--f11f6";
export var cardsContainer = "ExperienceCardModule-module--cardsContainer--d5dd8";
export var contentContainer = "ExperienceCardModule-module--contentContainer--4b187";
export var experienceTitle = "ExperienceCardModule-module--experienceTitle--5f31f";
export var overlay = "ExperienceCardModule-module--overlay--eb5bf";
export var priceTag = "ExperienceCardModule-module--priceTag--5a002";
export var text = "ExperienceCardModule-module--text--e03ae";
export var textContainer = "ExperienceCardModule-module--textContainer--8b886";
export var title = "ExperienceCardModule-module--title--8deba";
export var titleAndTextContainer = "ExperienceCardModule-module--titleAndTextContainer--c0608";
export var titleGoIcon = "ExperienceCardModule-module--titleGoIcon--baa22";